import { TbCopy, TbEye, TbEyeOff, TbPlus, TbTrash } from "react-icons/tb";
import { MastercardLogo } from "./MastercardLogo";

const DEMO_VIRTUAL_CARDS = [
  {
    id: "v1",
    name: "Compras online",
    last4: "4821",
    limit: "R$ 1.500,00",
    used: "R$ 320,00",
    status: "active",
  },
  {
    id: "v2",
    name: "Assinaturas",
    last4: "9034",
    limit: "R$ 500,00",
    used: "R$ 89,90",
    status: "active",
  },
];

export const VirtualCardsGrid = () => (
  <div className="space-y-4">
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h3 className="text-sm font-bold text-brand-dark">Cartões virtuais</h3>
        <p className="mt-0.5 text-xs text-gray-500">
          Use números temporários para compras online com mais segurança.
        </p>
      </div>
      <button type="button" className="btn-primary !px-4 !py-2 text-sm opacity-60" disabled>
        <span className="inline-flex items-center gap-2">
          <TbPlus className="h-4 w-4" />
          Criar cartão virtual
        </span>
      </button>
    </div>

    <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
      {DEMO_VIRTUAL_CARDS.map((card) => (
        <article key={card.id} className="cartoes-virtual-card">
          <div className="cartoes-virtual-card__top">
            <div>
              <p className="text-sm font-semibold text-brand-dark">{card.name}</p>
              <p className="mt-1 font-mono text-xs tracking-widest text-gray-500">
                •••• •••• •••• {card.last4}
              </p>
            </div>
            <MastercardLogo className="cartoes-virtual-card__brand" />
          </div>

          <div className="mt-4 flex items-center justify-between gap-2">
            <span className="cartoes-virtual-card__badge">Ativo</span>
          </div>

          <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
            <div className="rounded-lg bg-brand-surface px-3 py-2">
              <p className="text-gray-400">Limite</p>
              <p className="mt-0.5 font-semibold text-brand-dark">{card.limit}</p>
            </div>
            <div className="rounded-lg bg-brand-surface px-3 py-2">
              <p className="text-gray-400">Utilizado</p>
              <p className="mt-0.5 font-semibold text-brand-dark">{card.used}</p>
            </div>
          </div>

          <div className="mt-4 flex flex-wrap gap-2">
            <button type="button" className="cartoes-icon-btn" title="Mostrar dados">
              <TbEye className="h-4 w-4" />
            </button>
            <button type="button" className="cartoes-icon-btn" title="Ocultar dados">
              <TbEyeOff className="h-4 w-4" />
            </button>
            <button type="button" className="cartoes-icon-btn" title="Copiar número">
              <TbCopy className="h-4 w-4" />
            </button>
            <button type="button" className="cartoes-icon-btn cartoes-icon-btn--danger" title="Excluir">
              <TbTrash className="h-4 w-4" />
            </button>
          </div>
        </article>
      ))}

      <button type="button" className="cartoes-virtual-card cartoes-virtual-card--new" disabled>
        <MastercardLogo className="cartoes-virtual-card__brand cartoes-virtual-card__brand--muted" />
        <p className="mt-3 text-sm font-semibold text-brand-dark">Novo cartão virtual</p>
        <p className="mt-1 text-xs text-gray-500">Em breve na plataforma</p>
      </button>
    </div>
  </div>
);
